<plotly-plot
  [data]="data"
  [layout]="layout"
  [config]="config"
  class="plot"
></plotly-plot>
